<template>
    <div class="body">
        <p  class="p1" style="padding-top: 8vh;">Hi~ <a class="highlight">{{ ReportData.stuname }}</a>，我们又见面啦</p>
        <div v-if="ReportData.studate !==null">
          <p  class="p2">学习不停歇，收获满满哟，加油!</p>
          <p class="p3">2025年9月</p>
          <p class="p3">你在富学宝典平台上学习了<a class="highlight">{{ ReportData.studate }}</a>天</p>
          <p class="p4" v-if="ReportData.playtime && ReportData.playtime > 0">累计学习<a class="highlight">{{ ReportData.playtime }}</a>小时</p>
          <p class="p5">每一天的学习，都是你进步的见证</p>
          <p class="p6">每一个刻苦学习的瞬间，都是未来成功的基石</p>
        </div>
       
        <!-- <p class="p7">保持这份热忱</p>
        <p class="p8">梦想终将在你手中绽放</p> -->

        <p class="p3" style="margin: 0 auto;padding-top: 1.5vh;" v-if="ReportData.studate ===null">你还没有在富学宝典上学习，<br>请继续加油！</p>
        <p class="p10" style="font-size: 15px;text-align: center;margin: 0;;margin-top: 5vh;color: #0D1B2A;">左滑，开启专属于你的学习报告吧～</p>
    </div>
</template>
  
<script>
export default {
    props: [ "ReportData"]
}
</script>

<style scoped>
.body {
    background: url("../../assets/25September/logo.png") right  top  no-repeat,
                url("../../assets/25May/icon.png") 49% calc(100% + 50px) no-repeat,
                url("../../assets/25September/bg.jpg")  no-repeat;
    background-size:100% 100%, 55%,cover;
    width: 100%;
    height: 100vh;
}
.p1,.p2, .p3, .p4 {
    width: 92%;
    margin: 0;
    text-align: right;
    font-size: 18px;
    color: #0D1B2A;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
  .highlight {
    font-size: 30px;
    color: #fff;
    /* text-shadow:  -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000; */
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
 
  .p5, .p6, .p7, .p8{
    width: 92%;
    margin: 0;
    text-align: right;
    font-size: 16px;
    color: #0D1B2A;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }

  .p5, .p7{
    margin-top: 20px;
  }
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25September/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .p1,.p2, .p3, .p4 {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    font-size: 25px;
    color: #000;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .highlight {
    font-size: 30px;
    color: #fff;
    /* text-shadow:  -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000; */
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
 
  .p5, .p6, .p7, .p8{
    margin:0 auto;
    text-align: center;
    font-size: 20px;
    width: 92%;
  }

  .p5, .p7{
    margin-top: 20px;
  }
}
</style>